import React, { useState, useEffect, useRef } from "react";
import { GoogleMap, LoadScript, Marker, InfoWindow } from "@react-google-maps/api";
import Swal from "sweetalert2";
import Iconmap from "../../assets/images/marker.png";
import { formatDuration, intervalToDuration } from "date-fns";

const MapContainer = ({ places, center, googleMapsApiKey, onInterestClick }) => {
  const [state, setState] = useState({
    showingInfoWindow: false,
    activeMarker: null,
    selectedPlace: {},
    userLocation: { lat: -23.55052, lng: -46.633308 }, // Default para São Paulo
    loading: true,
  });

  const mapRef = useRef(null);

  useEffect(() => {
    requestLocation();
  }, []);

  useEffect(() => {
    if (center && mapRef.current) {
      mapRef.current.panTo(center);
    }
  }, [center]);

  const requestLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
          (position) => {
            setState((prevState) => ({
              ...prevState,
              userLocation: {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              },
              loading: false,
            }));
          },
          () => {
            setState((prevState) => ({
              ...prevState,
              loading: false,
            }));
            Swal.fire({
              title: "Acesso à Localização Negado",
              text: "O acesso à localização é necessário para exibir o mapa. Por favor, habilite os serviços de localização nas configurações do seu navegador.",
              icon: "error",
              confirmButtonText: "Tentar Novamente",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          }
      );
    } else {
      setState((prevState) => ({
        ...prevState,
        loading: false,
      }));
      Swal.fire({
        title: "Geolocalização Não Suportada",
        text: "Seu navegador não suporta geolocalização.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const calculateDuration = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const duration = intervalToDuration({ start: startDate, end: endDate });
    return formatDuration(duration, { format: ["hours", "minutes"] });
  };

  const onMarkerClick = (place, marker) => {
    setState({
      selectedPlace: place,
      activeMarker: marker,
      showingInfoWindow: true,
    });
  };
  const options = {
    clickableIcons: false, // Disable clicks on default POI icons like churches, stores, etc.
    zoomControl: true,
    styles: [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }], // Optionally hide all POI labels
      },
    ],
  };


  return (
      <div className="map-container">
        {state.loading ? (
            <div>Carregando...</div>
        ) : (
            <LoadScript googleMapsApiKey={googleMapsApiKey}>
              <GoogleMap
                  mapContainerStyle={{ height: "100vh", width: "100%" }}
                  center={state.userLocation}
                  zoom={13}
                  onLoad={(map) => (mapRef.current = map)}
                  options={options}
              >
                {places.map((place) => (
                    <Marker
                        key={place.id}
                        position={{ lat: place.lat, lng: place.lng }}
                        icon={Iconmap}
                        onClick={(e) => onMarkerClick(place, e)}
                    />
                ))}
                {state.showingInfoWindow && (
                    <InfoWindow
                        position={{ lat: state.activeMarker.latLng.lat(), lng: state.activeMarker.latLng.lng() }}
                        onCloseClick={() => setState({ ...state, showingInfoWindow: false })}
                    >
                      <div
                          className="profile-widget"
                          style={{ width: "100%", display: "inline-block" }}
                      >
                        <div className="doc-img">
                          <a
                              href={state.selectedPlace.profile_link}
                              tabIndex={0}
                              target="_blank"
                              rel="noopener noreferrer"
                          >
                            <img
                                style={{ height: "auto", width: "200px" }}
                                alt={state.selectedPlace.doc_name}
                                src={state.selectedPlace.image}
                            />
                          </a>
                        </div>
                        <div className="pro-content">
                          <h3 className="title">
                            {state.selectedPlace.doc_name}
                          </h3>
                          <ul className="available-info">
                            <li>
                              <i className="fa fa-map-marker-alt"></i>{" "}
                              {state.selectedPlace.cityName}, {state.selectedPlace.uf}
                            </li>
                            <li>
                              <i className="far fa-calendar"></i> Início{" "}
                              {new Date(state.selectedPlace.date_time).toLocaleDateString(
                                  "pt-BR"
                              )}{" "}
                              {new Date(
                                  state.selectedPlace.date_time
                              ).toLocaleTimeString("pt-BR", {
                                hour: "2-digit",
                                minute: "2-digit",
                              })}
                            </li>
                            <li>
                              <i className="far fa-calendar"></i> Término{" "}
                              {new Date(
                                  state.selectedPlace.date_time_end
                              ).toLocaleDateString("pt-BR")}{" "}
                              {new Date(
                                  state.selectedPlace.date_time_end
                              ).toLocaleTimeString("pt-BR", {
                                hour: "2-digit",
                                minute: "2-digit",
                              })}
                            </li>
                            <li>
                              <i className="far fa-clock"></i> Duração:{" "}
                              {calculateDuration(
                                  state.selectedPlace.date_time,
                                  state.selectedPlace.date_time_end
                              )}
                            </li>
                            <li>
                              <i className="far fa-money-bill-alt"></i> R${" "}
                              {state.selectedPlace.value}{" "}
                            </li>
                          </ul>
                          <button type="button"
                              className={`btn btn-sm ${state.selectedPlace.interest ? 'btn-danger' : 'btn-info'}`}
                              onClick={() => onInterestClick(state.selectedPlace.id, state.selectedPlace.interest)}
                          >
                            {state.selectedPlace.interest ? 'Cancelar Interesse' : 'Interesse'}
                          </button>
                        </div>
                      </div>
                    </InfoWindow>
                )}
              </GoogleMap>
            </LoadScript>
        )}
      </div>
  );
};

export default MapContainer;
